import {ToastrService} from 'ngx-toastr';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {Component, OnInit, EventEmitter, Output, AfterViewInit, OnDestroy} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router, ActivatedRoute} from '@angular/router';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {CommonService} from 'src/app/core/services/common.service';
import {I18nService} from './../../../../core/i18n.service';
import {AuthenticationService} from 'src/app/core/services/authentication.service';
import {Message} from 'src/app/core/class/message';
import {WarningSmsContractService} from '../../../../core/services/warning-sms-contract.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Subscription} from 'rxjs';
import {ResponsiveService} from '../../../../core/services/responsive.service';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {MatDialog} from '@angular/material';
import {AlertComponent} from 'src/app/shared/components/alert/alert.component';
import {MultiDownloadService} from '../../../../core/services/multi-download.service';
import {EnumDownloadMenuName} from '../../../../core/constants/common';
import {DocumentService} from '../../../../core/services/document.service';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-home-enterprise',
  templateUrl: './home-enterprise.component.html',
  styleUrls: ['./home-enterprise.component.scss']
})
export class HomeEnterpriseComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  navOpened: boolean = true;
  isShowMenuSideBarLeft: boolean = true;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  dataStateUrl: any;

  constructor(
    public commonService: CommonService,
    private translate: TranslateService,
    private changeLanguageService: I18nService,
    public message: Message,
    private auth: AuthenticationService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public deviceService: DeviceDetectorService,
    private responsiveService: ResponsiveService,
    private digitalCertificateService: DigitalCertificateService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private documentService: DocumentService
  ) {
    super(commonService, message);
    this.setDefaultLanguage();
    //this.loadCheckShowMenuLeft();
    const currentNavigation = this.router.getCurrentNavigation();
    if (currentNavigation) {
      this.dataStateUrl = currentNavigation.extras.state;
    }
  }

  @Output() changeLanguage = new EventEmitter<boolean>();

  ngOnInit() {
    if (this.dataStateUrl !== undefined && this.dataStateUrl.key === 'send-confirm') {
      this.digitalCertificateService.changeConfirmRenewCertificateStatus(this.dataStateUrl.certificateId, this.dataStateUrl.serialNumber)
        .subscribe(res => {
          if (res.success) {
            if (res.data === 'PERMISSION_NOT_FOUND') {
              this.dialog.open(AlertComponent, {
                width: '350px',
                data: this.commonService.format(this.message.getMessage('messages.update_certificate_renew_permission_error'))
              });
            } else if (res.data === 'INTERNAL_SERVER_ERROR') {
              this.dialog.open(AlertComponent, {
                width: '350px',
                data: this.commonService.format(this.message.getMessage('messages.update_certificate_renew_server_error'))
              });
            } else if (res.data.issuedBy !== 'confirmed') {
              this.dialog.open(AlertComponent, {
                width: '400px',
                data: this.commonService.format(this.message.getMessage('messages.update_certificate_renew_success'), res.data.serialNumber)
              });
            } else {
              let date = (new Date(res.data.confirmRenewDate).getDate() < 10 ? '0' + new Date(res.data.confirmRenewDate).getDate() : new Date(res.data.confirmRenewDate).getDate())
                + '/' + ((new Date(res.data.confirmRenewDate).getMonth() + 1) < 10 ? '0' + (new Date(res.data.confirmRenewDate).getMonth() + 1) : new Date(res.data.confirmRenewDate).getMonth() + 1)
                + '/' + new Date(res.data.confirmRenewDate).getFullYear();
              this.dialog.open(AlertComponent, {
                width: '400px',
                data: this.commonService.format(this.message.getMessage('messages.re_updated_certificate_renew_warning'), date)
              });
            }
          }
        }, err => {
          this.dialog.open(AlertComponent, {
            width: '350px',
            data: this.commonService.format(this.message.getMessage('messages.update_certificate_renew_server_error'))
          });
        });
    }
  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
        }
      }
    );
  }


  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  setDefaultLanguage() {
    if (this.getLanguagelocalStored() === null) {
      this.translate.setDefaultLang('vi');
      this.setLanguagelocalStored('vi');

    } else {
      this.translate.setDefaultLang(this.getLanguagelocalStored());
    }
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['enterprise-login']);
  }

  openNav() {
    this.navOpened = !this.navOpened;
  }

  loadCheckShowMenuLeft() {
    if (this.activatedRoute.snapshot.firstChild.url[0].path == 'view-document' || this.activatedRoute.snapshot.firstChild.url[0].path == 'update-document' || this.activatedRoute.snapshot.firstChild.url[0].path === 'add-document') {
      this.isShowMenuSideBarLeft = false;
    } else {
      this.isShowMenuSideBarLeft = true;
    }
  }

  // loadCheckShowMenuLeft(){
  //   // console.log("get all URL: ", this.router.url);
  //   // console.log("get first parent URL: ", activatedRoute.snapshot.url[0].path);
  //   // console.log("get first child URL: ", this.activatedRoute.snapshot.firstChild.url[0].path);
  //
  //   if(this.router.url === '/home-enterprise/add-document'){
  //     this.isShowMenuSideBarLeft = false;
  //   }
  //   else{
  //     if(this.activatedRoute.snapshot.firstChild.url[0].path == 'view-document' || this.activatedRoute.snapshot.firstChild.url[0].path == 'update-document'){
  //       this.isShowMenuSideBarLeft = false;
  //     }
  //     else{
  //       this.isShowMenuSideBarLeft = true;
  //     }
  //   }
  // }

}
